import React from 'react';
import BrandDetail from '../components/BrandDetail';

const Arbor = () => {
  return <BrandDetail brandSlug="arbor" />;
};

export default Arbor;
